"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleTravelAgent = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
let SimpleTravelAgent = class SimpleTravelAgent {
    fullName;
    discountCoefficient = 0;
    commissionPercentage = 0;
    agentId;
    category;
    hostAgencyId;
    countryName;
    userId;
    approvedAt;
    createdAt;
    declinedAt;
    declinationReason;
    email;
    ownerId;
    partnerBookingAvailable;
    lastLoginAt;
    automaticEmails;
};
exports.SimpleTravelAgent = SimpleTravelAgent;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleTravelAgent.prototype, "fullName", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], SimpleTravelAgent.prototype, "discountCoefficient", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], SimpleTravelAgent.prototype, "commissionPercentage", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleTravelAgent.prototype, "agentId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.TravelAgentCategory),
    __metadata("design:type", String)
], SimpleTravelAgent.prototype, "category", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleTravelAgent.prototype, "hostAgencyId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleTravelAgent.prototype, "countryName", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleTravelAgent.prototype, "userId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], SimpleTravelAgent.prototype, "approvedAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], SimpleTravelAgent.prototype, "createdAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], SimpleTravelAgent.prototype, "declinedAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleTravelAgent.prototype, "declinationReason", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleTravelAgent.prototype, "email", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleTravelAgent.prototype, "ownerId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], SimpleTravelAgent.prototype, "partnerBookingAvailable", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], SimpleTravelAgent.prototype, "lastLoginAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], SimpleTravelAgent.prototype, "automaticEmails", void 0);
exports.SimpleTravelAgent = SimpleTravelAgent = __decorate([
    (0, class_transformer_1.Exclude)()
], SimpleTravelAgent);
//# sourceMappingURL=SimpleTravelAgent.js.map